import React, { useEffect } from "react";
import { Formik, Field, Form as FormikForm } from "formik";
import * as Yup from "yup";
import { Link, useNavigate } from "react-router-dom";
import Layout from "../Componants/Layout";
import { useMutation } from "@tanstack/react-query";
import { postRequest } from "../services/apiMethods";
import toast from "react-hot-toast";


// 🔐 Yup Validation Schema
const validationSchema = Yup.object().shape({
  email: Yup.string().email("Invalid email address").required("Email is required"),
  password: Yup.string().min(6, "Password must be at least 6 characters").required("Password is required"),
});



export default function LogIn() {
  const navigate = useNavigate();

  const { mutate, isLoading: apiState } = useMutation({
    mutationFn: (data) => postRequest(`/auth/login`, data),
    onSuccess: (data) => {
      localStorage.setItem("token", data?.value?.token);
      localStorage.setItem("isPasswordSet", data?.data?.isPasswordSet);
      localStorage.setItem("role", data?.data?.role);
      toast.success(`${data?.message}`, {
        iconTheme: {
          primary: "#337FE0",
          secondary: "#FFFAEE",
        },
      });
      localStorage.removeItem("forgotToken");
      window.location.href = "/dashboard";
    },
    onError: (error) => {
      console.error("Error during API call:", error);
    },
  });

  const handleSubmit = (values) => {
    const fcm_token = localStorage.getItem("fcm_token") || "";
    const deviceType = localStorage.getItem("deviceType") || "";

    const payload = {
      ...values,
      deviceType: deviceType,
      deviceToken: fcm_token,
    };

    console.log("Submitting Payload:", payload);

    mutate(payload, {
      onError: (error) => {
        console.error("Submission Error:", error);
      },
    });
  };

  useEffect(() => {
    const isInstagram = navigator.userAgent.includes("Instagram");
  
    if (!isInstagram) {
      import("../hooks/fcmHelper").then(({ fetchFCMToken }) => {
        fetchFCMToken();
      });
    } else {
      console.log("Skipping FCM token fetch in Instagram browser");
    }
  }, []);
  


  return (
    <Layout>
      <section>
        <div className="comn-form-box">
          <div>
            <h2>Log In</h2>
            <p>Welcome back! Log in to your account below</p>
            <Formik
              initialValues={{ email: "", password: "" }}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
            >
              {({ errors, touched }) => (
                <FormikForm className="cmn-form-set">
                  <div className="mb-3">
                    <label htmlFor="email" className="form-label">Email</label>
                    <Field
                      name="email"
                      type="email"
                      placeholder="Enter email"
                      className={`form-control ${errors.email && touched.email ? "is-invalid" : ""}`}
                    />
                    {errors.email && touched.email && (
                      <div className="invalid-feedback">{errors.email}</div>
                    )}
                  </div>

                  <div className="mb-3">
                    <div className="pswd-w-link">
                      <label htmlFor="password" className="form-label">Password</label>
                      <Link to="/forgot-password">Forgot Password?</Link>
                    </div>
                    <Field
                      name="password"
                      type="password"
                      placeholder="Password"
                      className={`form-control ${errors.password && touched.password ? "is-invalid" : ""}`}
                    />
                    {errors.password && touched.password && (
                      <div className="invalid-feedback">{errors.password}</div>
                    )}
                  </div>

                  <div className="cmn-form-action">
                    <button type="submit" className="theme-btn">
                      {apiState ? "loading..." : "Log in"}
                    </button>
                    <Link to="/" className="white-btn">
                      Find a Trusted Electrician
                    </Link>
                  </div>
                </FormikForm>
              )}
            </Formik>
          </div>
        </div>
      </section>
    </Layout>
  );
}
